import React, { useState, useEffect, Children } from "react";
import get from "lodash/get";
import { Card } from "react-bootstrap";

import { DYNAMIC_TABLE_ATTRIBUTE_LIST_BY_TABLE_ID_GET } from "../../../api/ApiConst";
import { GENERIC_API_LIST } from "../../../settings/constants/genericAPI";
import apiCaller from "../../../api/ApiCaller";
import APIView from "./APIView";

const API_LIST = Object.values(GENERIC_API_LIST);

const TableAPIListing = ({ tableData = {} }) => {
  const [columns, setColumns] = useState([]);
  const tableId = get(tableData, "id");
  const formAttributeColumns = columns
    .filter((attr) => attr?.formAttribute)

  useEffect(() => {
    if (tableId) {
      apiCaller.callPostApi(
        DYNAMIC_TABLE_ATTRIBUTE_LIST_BY_TABLE_ID_GET.replaceAll(
          "{dynamic-table-id}",
          tableId
        ),
        {},
        null,
        (response) => setColumns(get(response, "data", [])),
        () => setColumns([])
      );
    }
  }, [tableId]);

  return (
    <div className="col-12 my-3">
      <Card>
        <Card.Body>
          <div className="text-center">
            <h5>Table {get(tableData, "name", "")} API's</h5>
            {Children.toArray(
              API_LIST.map((apiParams, index) => (
                <APIView
                  index={index}
                  pathValue={get(tableData, "pathValue", "")}
                  apiParams={apiParams}
                  formAttributeColumns={formAttributeColumns}
                />
              ))
            )}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default TableAPIListing;
